import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Catalog from "@/pages/Catalog";
import WineDetail from "@/pages/WineDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SubmitWines from "@/pages/SubmitWines";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Membership from "@/pages/Membership";
import MembershipSuccess from "@/pages/MembershipSuccess";
import Marketplace from "@/pages/Marketplace";
import RequireAuth from "@/components/RequireAuth";
import RequireMembership from "@/components/RequireMembership";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <FavoritesProvider>
        <div className="min-h-screen bg-wine-bg">
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/wines/:id" element={<WineDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/submit-wines" element={<SubmitWines />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/membership/success" element={<RequireAuth><MembershipSuccess /></RequireAuth>} />
            <Route path="/marketplace" element={<RequireMembership><Marketplace /></RequireMembership>} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </div>
        <Toaster theme="dark" position="top-right" richColors />
        </FavoritesProvider>
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
